export default {
    namespaced: true,

    state: {
        appointments: null,
    },

    actions: {
        reset({ commit }) {
            commit('setAppointments', null);
        },
        /*
        getPropertyAppointments({ commit }, { propertyPK, tenancyPK }) {
            return axios.get(`/api/contacts/properties/${propertyPK}/appointments`, {
                params: {
                    tenancyPK: tenancyPK,
                },
            })
            .then((response) => {
                commit('setAppointments', response.data.data);
            })
            .catch(() => {
                commit('setAppointments', null);
            });
        },
        */
        getTenancyAppointments({ commit }, { tenancyPK }) {
            return axios.get(`/api/contacts/tenancies/${tenancyPK}/appointments`)
            .then((response) => {
                commit('setAppointments', response.data.data);
            })
            .catch(() => {
                commit('setAppointments', null);
            });
        },
    },

    mutations: {
        setAppointments(state, appointments) {
            state.appointments = appointments;
        },
    },
};
